import {ComponentType}                                                        from '@angular/cdk/portal';
import {Injectable}                                                           from '@angular/core';
import {CrudRecordIntf, CrudRecordType, CrudRecordTypes, GlobalDataTypesDict} from '@djsharkk/logr-types';
import {BehaviorSubject}                                                      from 'rxjs';
import {v4 as uuidv4}                                                         from 'uuid';
import {MenuCrudPanelBodyBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-body-bot/menu-crud-panel-body-bot.component';
import {MenuCrudPanelCaffBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-caff-bot/menu-crud-panel-caff-bot.component';
import {MenuCrudPanelFoodBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-food-bot/menu-crud-panel-food-bot.component';
import {MenuCrudPanelMedsBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-meds-bot/menu-crud-panel-meds-bot.component';
import {MenuCrudPanelMindBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-mind-bot/menu-crud-panel-mind-bot.component';
import {MenuCrudPanelMoodBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-mood-bot/menu-crud-panel-mood-bot.component';
import {MenuCrudPanelVapeBotComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-bot/menu-crud-panel-vape-bot/menu-crud-panel-vape-bot.component';
import {MenuCrudPanelContentBase}                                             from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-content-base';
import {MenuCrudPanelBodyTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-body-top/menu-crud-panel-body-top.component';
import {MenuCrudPanelCaffTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-caff-top/menu-crud-panel-caff-top.component';
import {MenuCrudPanelFoodTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-food-top/menu-crud-panel-food-top.component';
import {MenuCrudPanelMedsTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-meds-top/menu-crud-panel-meds-top.component';
import {MenuCrudPanelMindTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-mind-top/menu-crud-panel-mind-top.component';
import {MenuCrudPanelMoodTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-mood-top/menu-crud-panel-mood-top.component';
import {MenuCrudPanelVapeTopComponent}                                        from '../comps/menu-crud/menu-crud-panel/menu-crud-panel-top/menu-crud-panel-vape-top/menu-crud-panel-vape-top.component';
import {MenuBase}                                                             from './menu-base';

export type CrudMenuModeType =
	| null
	| 'capturing'
	| 'processing'
	| 'reviewing'
	| 'awaiting'

@Injectable({
				providedIn: 'root'
			})
export class MenuCrudService implements MenuBase<CrudRecordType, MenuCrudPanelContentBase<CrudRecordIntf, any>> {

	panelMenuCompsTop: { [key in CrudRecordType]: ComponentType<MenuCrudPanelContentBase<CrudRecordIntf, any>> } = {
		vape: MenuCrudPanelVapeTopComponent,
		meds: MenuCrudPanelMedsTopComponent,
		mood: MenuCrudPanelMoodTopComponent,
		mind: MenuCrudPanelMindTopComponent,
		body: MenuCrudPanelBodyTopComponent,
		caff: MenuCrudPanelCaffTopComponent,
		food: MenuCrudPanelFoodTopComponent
	}

	panelMenuCompsBot: { [key in CrudRecordType]: ComponentType<MenuCrudPanelContentBase<CrudRecordIntf, any>> } = {
		vape: MenuCrudPanelVapeBotComponent,
		meds: MenuCrudPanelMedsBotComponent,
		mood: MenuCrudPanelMoodBotComponent,
		mind: MenuCrudPanelMindBotComponent,
		body: MenuCrudPanelBodyBotComponent,
		caff: MenuCrudPanelCaffBotComponent,
		food: MenuCrudPanelFoodBotComponent
	}


	menuOpen = new BehaviorSubject<boolean>(false);
	menuType = new BehaviorSubject<CrudRecordType | undefined>(undefined);
	menuPanels = CrudRecordTypes.map(type => {
										 console.log(type)
										 return {
											 uuid: uuidv4(),
											 type,
											 icon: GlobalDataTypesDict[type].icon,
											 name: GlobalDataTypesDict[type].name,
											 comp: this.panelMenuCompsTop[type]
										 }
									 }
	)


	crudMenuFoodMode: CrudMenuModeType = null;


}
